(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-list"]) return;
  try {
    
  // Set optimal grid columns based on collection count and screen size
  function setOptimalColumnsForCollections() {
    const resourceList = document.querySelector('.resource-list--grid');
    if (resourceList && typeof calculateOptimalColumns === 'function') {
      const collectionItems = resourceList.querySelectorAll('.resource-list__item');
      const collectionCount = collectionItems.length;
      
      if (collectionCount > 0) {
        const screenWidth = window.innerWidth;
        let minColumns, maxColumns;
        
        if (screenWidth < 750) {
          // Mobile: 1-2 columns
          minColumns = 1;
          maxColumns = 2;
        } else if (screenWidth < 990) {
          // Tablet: 2-4 columns
          minColumns = 2;
          maxColumns = 4;
        } else {
          // Desktop: 3-5 columns
          minColumns = 3;
          maxColumns = 5;
        }
        
        const optimalColumns = calculateOptimalColumns(collectionCount, minColumns, maxColumns);
        resourceList.style.setProperty('--resource-list-columns', `repeat(${optimalColumns}, 1fr)`);
      }
    }
  }
  
  document.addEventListener('DOMContentLoaded', setOptimalColumnsForCollections);
  window.addEventListener('resize', setOptimalColumnsForCollections);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Set optimal grid columns based on product count and screen size
  function setOptimalColumns() {
    const productGrid = document.querySelector('.product-grid');
    const resultsContainer = document.querySelector('results-list');

    if (productGrid && resultsContainer && typeof calculateOptimalColumns === 'function') {
      // Get total collection product count from data attribute
      const totalProductCount = parseInt(resultsContainer.getAttribute('data-total-products'));

      if (totalProductCount > 0) {
        const screenWidth = window.innerWidth;
        let minColumns, maxColumns;

        if (screenWidth < 750) {
          // Mobile: 1-2 columns
          minColumns = 1;
          maxColumns = 2;
        } else if (screenWidth < 990) {
          // Tablet: 2-4 columns
          minColumns = 2;
          maxColumns = 4;
        } else {
          // Desktop: 3-5 columns
          minColumns = 3;
          maxColumns = 5;
        }

        const optimalColumns = calculateOptimalColumns(totalProductCount, minColumns, maxColumns);
        productGrid.style.setProperty('--product-grid-columns-desktop', `repeat(${optimalColumns}, 1fr)`);
      }
    }
  }

  // Run immediately when script loads (before DOMContentLoaded)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setOptimalColumns);
  } else {
    setOptimalColumns();
  }

  // Also run after a small delay to ensure CSS has loaded
  setTimeout(setOptimalColumns, 100);

  window.addEventListener('resize', setOptimalColumns);

  // Listen for filter/sorting updates to reapply column layout
  document.addEventListener('filter:update', () => {
    // Wait for the new DOM content to be inserted after section re-rendering
    setTimeout(setOptimalColumns, 100);
    setTimeout(setOptimalColumns, 500);
  });

  } catch(e) { console.error(e); }
})();
})();
